<template>
  <div>
    <div class="grid-content maintitle">
      <span>{{ $t("message.品牌编辑") }}</span>
    </div>
    <div class="topContainer">
      <div class="grid-content content-margin topFix">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button size="medium" round @click.native="goBack">
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isEditMode && !isInit">
            <el-button size="medium" round @click="isEditMode = true">
              <i class="iconfont">&#xe618;</i>
              {{ $t("message.修改") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSave" type="primary">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.保存") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="!isInit">
            <el-button size="medium" round @click.native="refresh">
              <i class="iconfont">&#xe667;</i>
              {{ $t("message.刷新") }}
            </el-button>
          </el-link>
        </div>
        <!-- <el-divider></el-divider> -->
      </div>
    </div>
    <div class="grid-content subtitle">
      <span>{{ $t("message.品牌主信息") }}</span>
    </div>
    <div class="grid-content content-margin">
      <table class="simpleRow">
        <tr v-if="brandid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.品牌ID") }}</span>
          </td>
          <td>
            <el-input v-model="brandid" readonly size="mini" placeholder="">
            </el-input>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.品牌名称") }}</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              v-model="name"
              size="mini"
              maxlength="10"
              :placeholder="$t('message.输入10个以内汉字')"
            />
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.品牌描述") }}</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              v-model="subname"
              size="mini"
              maxlength="20"
              :placeholder="$t('message.输入20个以内汉字')"
            />
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.品牌图片sel") }}</span>
          </td>
          <td>
            <!-- 图片库控件 -->
            <div
              :class="!isEditMode ? 'unsel-img-box' : 'sel-img-box'"
              @click="doShowResourceStore(1)"
            >
              <i class="iconfont" v-if="!img">&#xe727;</i>
              <el-popover placement="right" trigger="hover" v-else>
                <img
                  :src="'' + img"
                  alt=""
                  style="max-width: 500px; max-height: 500px"
                />
                <img slot="reference" :src="'' + img" />
                <el-button
                  v-if="isEditMode"
                  type="danger"
                  icon="el-icon-delete"
                  circle
                  @click.native="img = ''"
                ></el-button>
              </el-popover>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.跳转链接") }}</span>
          </td>
          <td>
            <el-input
              :readonly="!isEditMode"
              size="mini"
              class="linkTextArea"
              v-model="jumpurl"
              type="textarea"
              :placeholder="$t('message.请输入链接')"
              maxlength="2000"
              show-word-limit
            >
            </el-input>
          </td>
        </tr>
        <!-- <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.是否为外链") }}</span>
          </td>
          <td>
            <el-switch
              :disabled="!isEditMode"
              v-model="isLinkSwitch"
              :active-text="$t('message.是')"
              :inactive-text="$t('message.否')"
            ></el-switch>
          </td>
        </tr> -->
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.是否列表显示") }}</span>
          </td>
          <td>
            <el-switch
              :disabled="!isEditMode"
              v-model="isShowSwitch"
              :active-text="$t('message.是')"
              :inactive-text="$t('message.否')"
            ></el-switch>
          </td>
        </tr>
        <tr>
          <td>
            <span class="simpleLabel">{{ $t("message.优先级排序") }}</span>
          </td>
          <td>
            <el-input-number
              :min="0"
              :disabled="!isEditMode"
              size="mini"
              v-model="sort"
            ></el-input-number>
          </td>
        </tr>
        <tr v-if="brandid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建日期") }}</span>
          </td>
          <td>
            <el-input
              readonly
              v-model="createdate"
              size="mini"
              placeholder=""
            />
          </td>
        </tr>
        <tr v-if="brandid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.创建人") }}</span>
          </td>
          <td>
            <el-input readonly v-model="createid" size="mini" placeholder="" />
          </td>
        </tr>
        <tr v-if="brandid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新日期") }}</span>
          </td>
          <td>
            <el-input readonly v-model="editdate" size="mini" placeholder="" />
          </td>
        </tr>
        <tr v-if="brandid > 0">
          <td>
            <span class="simpleLabel">{{ $t("message.更新人") }}</span>
          </td>
          <td>
            <el-input readonly v-model="editid" size="mini" placeholder="" />
          </td>
        </tr>
      </table>
    </div>
    <div class="grid-content subtitle">
      <span>{{ $t("message.品牌详情管理") }}</span>
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button
            :disabled="!isEditMode"
            size="medium"
            round
            @click.native="createTarget"
          >
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.添加") }}
          </el-button>
        </el-link>
      </div>
    </div>
    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="filterData"
        stripe
        border
        :max-height="tableHeight"
        style="width: 100%"
      >
        <el-table-column fixed label="No." type="index" width="55">
        </el-table-column>
        <el-table-column
          fixed
          width="120"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                v-if="!isEditMode"
                size="mini"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editTarget(scope.row)"
              ></el-button>
              <el-button
                v-else
                size="mini"
                round
                type="normal"
                icon="el-icon-edit"
                @click="editTarget(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                :disabled="!isEditMode"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  targetRow = scope.row;
                  deleteDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="branddetailid"
          :label="$t('message.品牌详情ID')"
          width="150"
        >
        </el-table-column>
        <el-table-column
          sortable
          :label="$t('message.品牌详情类型')"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ getTypeName(scope.row.detailtypeid) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="title"
          :label="$t('message.标题')"
          width="150"
        >
        </el-table-column>
        <el-table-column
          :label="$t('message.主图片')"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.headimg != ''"
              placement="top-start"
              title=""
              trigger="hover"
            >
              <img
                :src="'' + scope.row.headimg"
                alt=""
                style="max-width: 500px; max-height: 500px"
              />
              <img
                slot="reference"
                :src="'' + scope.row.headimg"
                style="max-width: 120px; max-height: 30px"
              />
            </el-popover>
            <span v-else>{{ $t("message.无") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="content1"
          :label="$t('message.内容1')"
          min-width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          :label="$t('message.中间图片')"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.midimg != ''"
              placement="top-start"
              title=""
              trigger="hover"
            >
              <img
                :src="'' + scope.row.midimg"
                alt=""
                style="max-width: 500px; max-height: 500px"
              />
              <img
                slot="reference"
                :src="'' + scope.row.midimg"
                style="max-width: 120px; max-height: 30px"
              />
            </el-popover>
            <span v-else>{{ $t("message.无") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="content2"
          :label="$t('message.内容2')"
          min-width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          prop="jumpurl"
          :label="$t('message.跳转链接')"
          width="200"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          sortable
          :label="$t('message.是否列表显示')"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ $t(`message.${getBooleanName(scope.row.isshow)}`) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
            sortable
            prop="sort"
            label="排序"
            width="150"
            >
          </el-table-column> -->
      </el-table>
    </div>

    <div class="grid-content subtitle">
      <span>3.品牌海报图</span>
    </div>
    <div class="grid-content content-margin">
      <div class="buttonarea">
        <el-link :underline="false">
          <el-button
            :disabled="!isEditMode"
            size="medium"
            round
            @click.native="createPoster"
          >
            <i class="iconfont">&#xe727;</i>
            {{ $t("message.添加") }}
          </el-button>
        </el-link>
        <el-link :underline="false">
          <el-button size="medium" round @click.native="onPreview">
            <i class="el-icon-view"></i>
            预览
          </el-button>
        </el-link>
      </div>
    </div>
    <div class="grid-content content-margin">
      <el-table
        ref="table"
        :data="posterData"
        stripe
        border
        :max-height="tableHeight"
        style="width: 100%"
        :key="posterTableKey"
      >
        <el-table-column fixed label="No." type="index" width="55">
        </el-table-column>
        <el-table-column
          fixed
          width="160"
          :label="$t('message.操作')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button-group>
              <el-button
                size="mini"
                v-if="!isEditMode"
                round
                type="normal"
                icon="el-icon-zoom-in"
                @click="editPoster(scope.row, false)"
              ></el-button>
              <el-button
                size="mini"
                v-else
                round
                type="normal"
                icon="el-icon-edit"
                @click="editPoster(scope.row, true)"
              ></el-button>
              <el-button
                size="mini"
                :disabled="!isEditMode"
                round
                type="normal"
                icon="el-icon-delete"
                @click="
                  posterRow = scope.row;
                  deletePosterDialogVisible = true;
                "
              ></el-button>
            </el-button-group>
          </template>
        </el-table-column>
        <el-table-column
          label="海报图片750*min（any）"
          width="150"
          align="center"
        >
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.img != ''"
              placement="top-start"
              title=""
              trigger="hover"
            >
              <img
                :src="'' + scope.row.img"
                alt=""
                style="max-width: 500px; max-height: 500px"
              />
              <img
                slot="reference"
                :src="'' + scope.row.img"
                style="max-width: 120px; max-height: 30px"
              />
            </el-popover>
            <span v-else>{{ $t("message.无") }}</span>
          </template>
        </el-table-column>
        <el-table-column
          sortable
          prop="sort"
          :label="$t('message.排序')"
          min-width="150"
        >
        </el-table-column>
        <el-table-column
          sortable
          :label="$t('message.是否列表显示')"
          min-width="150"
        >
          <template slot-scope="scope">
            <span>{{ getBooleanName(scope.row.isshow) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deletePosterDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该内容") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deletePosterDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deletePoster">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>

    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showPosterDateilDrawer"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>海报图管理</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showPosterDateilDrawer = false"
            >
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSavePosterDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.图片") }}</span>
            </td>
            <td>
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(10086)">
                <i class="iconfont" v-if="!posterImg">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img
                    :src="'' + posterImg"
                    alt=""
                    style="max-width: 500px; max-height: 500px"
                  />
                  <img slot="reference" :src="'' + posterImg" />
                  <el-button
                    v-if="isEditMode"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click.native="posterImg = ''"
                  ></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.是否显示") }}</span>
            </td>
            <td>
              <el-switch
                :disabled="!isEditMode"
                v-model="posterIsShowSwitch"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"
              ></el-switch>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.优先级排序") }}</span>
            </td>
            <td>
              <el-input-number
                :min="0"
                :disabled="!isEditMode"
                size="mini"
                v-model="posterSort"
              ></el-input-number>
            </td>
          </tr>
        </table>
      </div>
    </el-drawer>

    <el-drawer
      :show-close="false"
      :size="800"
      :visible.sync="showDateilDrawer"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div class="grid-content subtitle">
        <span>{{ $t("message.品牌详情编辑") }}</span>
      </div>
      <div class="grid-content content-margin">
        <div class="buttonarea">
          <el-link :underline="false">
            <el-button
              size="medium"
              round
              @click.native="showDateilDrawer = false"
            >
              <i class="iconfont">&#xe600;</i>
              {{ $t("message.返回") }}
            </el-button>
          </el-link>
          <el-link :underline="false" v-show="isEditMode">
            <el-button size="medium" round @click="doSaveDetail">
              <i class="iconfont">&#xe769;</i>
              {{ $t("message.确定") }}
            </el-button>
          </el-link>
        </div>
        <el-divider></el-divider>
      </div>
      <div class="grid-content content-margin">
        <table class="simpleRow">
          <tr v-if="d_branddetailid > 0">
            <td>
              <span class="simpleLabel">{{ $t("message.品牌详情ID") }}</span>
            </td>
            <td>
              <el-input
                v-model="d_branddetailid"
                readonly
                size="mini"
                placeholder=""
              >
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.详情类型") }}</span>
            </td>
            <td>
              <el-select
                size="mini"
                :disabled="!isEditMode"
                v-model="d_detailtypeid"
                :placeholder="$t('message.请选择')"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.标题") }}</span>
            </td>
            <td>
              <el-input
                :readonly="!isEditMode"
                v-model="d_title"
                size="mini"
                maxlength="10"
                :placeholder="$t('message.输入10个以内汉字')"
              />
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.主图片sel") }}</span>
            </td>
            <td>
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(2)">
                <i class="iconfont" v-if="!d_headImg">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img
                    :src="'' + d_headImg"
                    alt=""
                    style="max-width: 500px; max-height: 500px"
                  />
                  <img slot="reference" :src="'' + d_headImg" />
                  <el-button
                    v-if="isEditMode"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click.native="d_headImg = ''"
                  ></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.内容1") }}</span>
            </td>
            <td>
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="d_content1"
                type="textarea"
                placeholder="请输入内容"
                maxlength="2000"
                show-word-limit
              >
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.中间图片sel") }}</span>
            </td>
            <td>
              <!-- 图片库控件 -->
              <div class="sel-img-box" @click="doShowResourceStore(3)">
                <i class="iconfont" v-if="!d_midImg">&#xe727;</i>
                <el-popover placement="right" trigger="hover" v-else>
                  <img
                    :src="'' + d_midImg"
                    alt=""
                    style="max-width: 500px; max-height: 500px"
                  />
                  <img slot="reference" :src="'' + d_midImg" />
                  <el-button
                    v-if="isEditMode"
                    type="danger"
                    icon="el-icon-delete"
                    circle
                    @click.native="d_midImg = ''"
                  ></el-button>
                </el-popover>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.内容2") }}</span>
            </td>
            <td>
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="d_content2"
                type="textarea"
                placeholder="请输入内容"
                maxlength="2000"
                show-word-limit
              >
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.跳转链接") }}</span>
            </td>
            <td>
              <el-input
                :readonly="!isEditMode"
                size="mini"
                class="linkTextArea"
                v-model="d_jumpurl"
                type="textarea"
                :placeholder="$t('message.请输入链接')"
                maxlength="2000"
                show-word-limit
              >
              </el-input>
            </td>
          </tr>
          <tr>
            <td>
              <span class="simpleLabel">{{ $t("message.是否列表显示") }}</span>
            </td>
            <td>
              <el-switch
                :disabled="!isEditMode"
                v-model="d_isShowSwitch"
                :active-text="$t('message.是')"
                :inactive-text="$t('message.否')"
              ></el-switch>
            </td>
          </tr>
          <!-- <tr>
              <td>
                <span class="simpleLabel">优先级排序(数字越小越靠前)</span>
              </td>
              <td >
                <el-input-number :min="0" :disabled="!isEditMode" size="mini" v-model="d_sort"></el-input-number>
              </td>
            </tr> -->
        </table>
      </div>
    </el-drawer>
    <el-dialog
      :title="$t('message.删除确认')"
      :visible.sync="deleteDialogVisible"
      width="300px"
      :modal="false"
      center
      :before-close="handleClose"
    >
      <i class="iconfont">&#xe766;</i>
      <span>{{ $t("message.请确认是否删除该内容") }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{
          $t("message.取消")
        }}</el-button>
        <el-button type="primary" @click.native="deleteTarget">{{
          $t("message.删除")
        }}</el-button>
      </span>
    </el-dialog>
    <shade v-if="showResourceStore > 0">
      <resource-store
        :shadeShow="showResourceStore > 0"
        @onClick="onResourceStoreCallback"
        :appID="appid"
      ></resource-store>
    </shade>
  </div>
</template>

<script>
import commonUtil from "@/utils/commonUtil";
import { topfixfunc } from "@/utils/topFix";
import ResourceStore from "@/components/resourceStore/resourceStore";
import shade from "@/components/shade/shade";
import { rejecthttp, changeflagCLOSED } from "@/utils/request";

export default {
  name: "BrandTypeDetail",
  components: {
    shade,
    ResourceStore,
  },
  data() {
    return {
      appid: 0,
      tableHeight: 500,
      typeOptions: [
        {
          value: "0",
          label: "加载中..",
          disabled: true,
        },
      ],
      brandid: 0,
      name: "",
      subname: "",
      img: "",
      jumpurl: "",
      sort: 0,
      createdate: "",
      createid: "",
      editdate: "",
      editid: "",
      isEditMode: true,
      isInit: true,
      isLinkSwitch: false,
      isShowSwitch: true,
      showResourceStore: 0,
      showDateilDrawer: false,
      tableData: [],
      targetRow: null,
      d_branddetailid: 0,
      d_detailtypeid: "",
      d_title: "",
      d_content1: "",
      d_content2: "",
      d_jumpurl: "",
      d_headImg: "",
      d_midImg: "",
      d_sort: 0,
      d_isShowSwitch: true,
      deleteDialogVisible: false,

      //产品海报编辑数据
      showPosterDateilDrawer: false,
      posterData: [],
      posterRow: null,
      posterImg: "",
      posterJumpUrl: "",
      posterIsShowSwitch: true,
      posterSort: 0,
      deletePosterDialogVisible: false,
      posterTableKey: 0,
    };
  },
  mounted: function () {
    topfixfunc();
    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度 //50表示你想要调整的表格距离底部的高度（你可以自己随意调整），因为我们一般都有放分页组件的，所以需要给它留一个高度
  },
  watch: {},
  methods: {
    doSavePosterDetail() {
      if (this.posterRow) {
        this.posterRow.img = this.posterImg;
        this.posterRow.jumpurl = this.posterJumpUrl;
        this.posterRow.isshow = this.posterIsShowSwitch ? 1 : 0;
        this.posterRow.sort = this.posterSort;
      } else {
        let item = {
          img: this.posterImg,
          jumpurl: this.posterJumpUrl,
          isshow: this.posterIsShowSwitch ? 1 : 0,
          sort: this.posterSort,
        };
        this.posterData.push(item);
      }
      this.sortPoster();
      this.showPosterDateilDrawer = false;
    },

    createPoster() {
      this.posterRow = null;
      this.posterImg = "";
      this.posterJumpUrl = "";

      this.posterIsShowSwitch = true;
      this.posterSort = 0;

      this.showPosterDateilDrawer = true;
    },

    editPoster(data, edit) {
      this.posterRow = data;
      //赋值
      this.posterImg = this.posterRow.img;
      this.posterJumpUrl = this.posterRow.jumpurl;
      this.posterIsShowSwitch = this.posterRow.isshow == 1 ? true : false;
      this.posterSort = this.posterRow.sort;
      this.showPosterDateilDrawer = true;
    },

    deletePoster() {
      console.log(this.posterRow);
      let index = this.posterData.findIndex((item) => {
        if (item == this.posterRow) {
          return true;
        }
      });
      this.posterData.splice(index, 1);
      this.deletePosterDialogVisible = false;
    },

    sortPoster() {
      this.posterData.sort(commonUtil.sortAsc, "sort");
      this.posterTableKey++;
    },

    onPreview() {
      let routeUrl = this.$router.resolve({
        path: "/ProductPosterPreview",
        query: {
          appid: this.appid,
          shelvesid: this.shelvesid,
          posters: JSON.stringify(this.posterData),
        },
      });
      window.open(routeUrl.href, "_blank");
    },

    goBack() {
      this.$router.go(-1); //返回上一层
    },
    doSave() {
      if (this.name == "") {
        this.$message({
          type: "error",
          message: this.$t("message.名称不能为空"),
        });
        return;
      }
      this.isEditMode = false;

      let sendObj = {
        appid: this.appid,
        brand: {
          appid: this.appid,
          brandid: this.brandid,
          name: this.name,
          subname: this.subname,
          img: this.img,
          jumpurl: this.jumpurl,
          islink: this.isLinkSwitch ? "1" : "0",
          isshow: this.isShowSwitch ? "1" : "0",
          sort: this.sort,
          createdate: "2021-07-21T07:17:22.619Z",
          createid: 0,
          editdate: "2021-07-21T07:17:22.619Z",
          editid: 0,
        },
        detail: this.tableData,
        posters: this.posterData,
      };
      if (this.isInit) {
        rejecthttp(
          true,
          "post",
          "/manage/brand/addbrandinfo",
          sendObj,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            // if(doc.data.Code == "MSGKEY_OK"){
            //  this.successMsgBox(doc.data.Message);
            //   this.openDirectory(
            //     this.currentData ? this.currentData.directoryID : "0"
            //   );
            // }
          }
        );
        // this.$http.post("/manage/brand/addbrandinfo", sendObj).then((doc) => {
        //   // console.log(doc.data)
        //   if (doc.data.Code != "MSGKEY_OK") {
        //     this.$message({
        //       type: "error",
        //       message: doc.data.Message,
        //     });
        //   } else {
        //     this.$message({
        //       type: "success",
        //       message: doc.data.Message,
        //     });
        //     this.$router.go(-1); //返回上一层
        //   }
        // });
      } else {
        rejecthttp(
          true,
          "post",
          "/manage/brand/updatebrandinfo",
          sendObj,
          this,
          (doc) => {
            changeflagCLOSED(doc, 1, this);
            // if(doc.data.Code == "MSGKEY_OK"){
            //  this.successMsgBox(doc.data.Message);
            //   this.openDirectory(
            //     this.currentData ? this.currentData.directoryID : "0"
            //   );
            // }
          }
        );
        // this.$http
        //   .post("/manage/brand/updatebrandinfo", sendObj)
        //   .then((doc) => {
        //     // console.log(doc.data)
        //     if (doc.data.Code != "MSGKEY_OK") {
        //       this.$message({
        //         type: "error",
        //         message: doc.data.Message,
        //       });
        //     } else {
        //       this.$message({
        //         type: "success",
        //         message: doc.data.Message,
        //       });
        //     }
        //   });
      }
    },
    doSaveDetail() {
      if (this.targetRow) {
        this.targetRow.brandid = this.brandid;
        this.targetRow.detailtypeid = this.d_detailtypeid;
        this.targetRow.title = this.d_title;
        this.targetRow.headimg = this.d_headImg;
        this.targetRow.content1 = this.d_content1;
        this.targetRow.midimg = this.d_midImg;
        this.targetRow.content2 = this.d_content2;
        this.targetRow.jumpurl = this.d_jumpurl;
        this.targetRow.isshow = this.d_isShowSwitch ? 1 : 0;
        this.targetRow.sort = this.d_sort;
      } else {
        let item = {
          branddetailid: 0,
          brandid: this.brandid,
          detailtypeid: this.d_detailtypeid,
          title: this.d_title,
          headimg: this.d_headImg,
          content1: this.d_content1,
          midimg: this.d_midImg,
          content2: this.d_content2,
          jumpurl: this.d_jumpurl,
          isshow: this.d_isShowSwitch ? 1 : 0,
          sort: this.d_sort,
        };
        this.tableData.push(item);
      }
      this.showDateilDrawer = false;
    },
    doShowResourceStore(type) {
      if (!this.isEditMode) return;
      this.showResourceStore = type;
    },
    onResourceStoreCallback(doc) {
      console.log(doc);
      if (doc) {
        switch (this.showResourceStore) {
          case 1:
            this.img = doc.resourceID;
            break;
          case 2:
            this.d_headImg = doc.resourceID;
            break;
          case 3:
            this.d_midImg = doc.resourceID;
            break;
          case 10086:
            this.posterImg = doc.resourceID;
            break;
        }

        this.showResourceStore = 0;
      } else {
        this.showResourceStore = 0;
      }
    },
    refresh() {
      // 获取类型列表
      rejecthttp(
        false,
        "get",
        "/manage/brand/getbrandtypelist",
        {
          appid: this.appid,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            //保存数据,并解析到下拉选单
            this.typeOptions = [];
            doc.data.data.forEach((any) => {
              let item = {
                value: any.detailtypeid,
                label: any.name,
              };
              this.typeOptions.push(item);
            });
          }
        }
      );
      // this.$http
      //   .get("/manage/brand/getbrandtypelist", {
      //     params: {
      //       appid: this.appid,
      //     },
      //   })
      //   .then((doc) => {
      //     if (doc.data.Code != "MSGKEY_OK") {
      //       this.$message({
      //         type: "error",
      //         message: doc.data.Message,
      //       });
      //     } else {
      //       console.log(doc.data);
      //       //保存数据,并解析到下拉选单
      //       this.typeOptions = [];
      //       doc.data.data.forEach((any) => {
      //         let item = {
      //           value: any.detailtypeid,
      //           label: any.name,
      //         };
      //         this.typeOptions.push(item);
      //       });
      //     }
      //   });
      if (!this.brandid) {
        return;
      }
      rejecthttp(
        false,
        "get",
        "/manage/brand/getbrandinfo",
        {
          appid: this.appid,
          brandid: this.brandid,
        },
        this,
        (doc) => {
          changeflagCLOSED(doc, 0, this);
          if (doc.data.Code == "MSGKEY_OK") {
            console.log(doc.data);
            this.brandid = doc.data.data.brand.brandid;
            this.name = doc.data.data.brand.name;
            this.subname = doc.data.data.brand.subname;
            this.img = doc.data.data.brand.img;
            this.jumpurl = doc.data.data.brand.jumpurl;
            this.isLinkSwitch =
              doc.data.data.brand.islink == "1" ? true : false;
            this.isShowSwitch =
              doc.data.data.brand.isshow == "1" ? true : false;
            this.sort = doc.data.data.brand.sort;
            this.createdate = commonUtil.formatDate(
              doc.data.data.brand.createdate
            );
            this.createid = doc.data.data.brand.createid;
            this.editdate = commonUtil.formatDate(doc.data.data.brand.editdate);
            this.editid = doc.data.data.brand.editid;
            this.tableData = doc.data.data.detail;
            if (!this.tableData) this.tableData = [];
            this.posterData = doc.data.data.posters;
            if (!this.posterData) {
              this.posterData = [];
            } else {
              this.sortPoster();
            }
          }
        }
      );
      // this.$http
      // .get("/manage/brand/getbrandinfo", {
      //   params: {
      //     appid: this.appid,
      //     brandid: this.brandid,
      //   },
      // })
      // .then((doc) => {
      //   if (doc.data.Code != "MSGKEY_OK") {
      //     this.$message({
      //       type: "error",
      //       message: doc.data.Message,
      //     });
      //   } else {
      //     console.log(doc.data);
      //     this.brandid = doc.data.data.brand.brandid;
      //     this.name = doc.data.data.brand.name;
      //     this.subname = doc.data.data.brand.subname;
      //     this.img = doc.data.data.brand.img;
      //     this.jumpurl = doc.data.data.brand.jumpurl;
      //     this.isLinkSwitch =
      //       doc.data.data.brand.islink == "1" ? true : false;
      //     this.isShowSwitch =
      //       doc.data.data.brand.isshow == "1" ? true : false;
      //     this.sort = doc.data.data.brand.sort;
      //     this.createdate = commonUtil.formatDate(
      //       doc.data.data.brand.createdate
      //     );
      //     this.createid = doc.data.data.brand.createid;
      //     this.editdate = commonUtil.formatDate(doc.data.data.brand.editdate);
      //     this.editid = doc.data.data.brand.editid;
      //     this.tableData = doc.data.data.detail;
      //     if (!this.tableData) this.tableData = [];
      //   }
      // });
    },
    createTarget() {
      this.d_branddetailid = 0;
      this.d_detailtypeid = "";
      this.d_title = "";
      this.d_content1 = "";
      this.d_content2 = "";
      this.d_jumpurl = "";
      this.d_headImg = "";
      this.d_midImg = "";
      this.d_sort = 0;
      this.d_isShowSwitch = true;
      this.targetRow = null;
      this.showDateilDrawer = true;
    },
    editTarget(data) {
      this.targetRow = data;
      this.showDateilDrawer = true;

      //赋值
      this.d_branddetailid = data.branddetailid;
      this.d_detailtypeid = data.detailtypeid;
      this.d_title = data.title;
      this.d_content1 = data.content1;
      this.d_content2 = data.content2;
      this.d_jumpurl = data.jumpurl;
      this.d_headImg = data.headimg;
      this.d_midImg = data.midimg;
      this.d_sort = data.sort;
      this.d_isShowSwitch = data.isshow == "1" ? true : false;
    },
    deleteTarget() {
      console.log(this.targetRow);
      let index = this.tableData.findIndex((item) => {
        if (item == this.targetRow) {
          return true;
        }
      });
      this.tableData.splice(index, 1);
      this.deleteDialogVisible = false;
    },
    getTypeName(id) {
      let result = "未选择";
      this.typeOptions.forEach((item) => {
        if (parseInt(item.value) == parseInt(id)) return (result = item.label);
      });
      return result;
    },
    getBooleanName(bool) {
      return commonUtil.getBooleanName(bool);
    },
    handleClose(done) {
      // 空函数, 防止dialog被不小心关闭
    },
    handleCloseDrawer(done) {
      this.$confirm(this.$t("message.确认关闭"))
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
  created() {
    this.appid = this.$route.query.appid ? this.$route.query.appid : 0;
    if (this.$route.query.id) {
      this.brandid = this.$route.query.id;
      this.isEditMode = this.$route.query.isEditMode ? true : false;
      this.isInit = false;
    }
    this.refresh();
  },
  computed: {
    filterData() {
      if (this.tableData)
        return this.tableData.filter(
          (data) =>
            !this.search ||
            data.branddetailid
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.title.toLowerCase().includes(this.search.toLowerCase()) ||
            data.content1.toLowerCase().includes(this.search.toLowerCase()) ||
            data.content2.toLowerCase().includes(this.search.toLowerCase()) ||
            data.jumpurl.toLowerCase().includes(this.search.toLowerCase()) ||
            data.brandid
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase())
        );
      else return [];
    },
  },
};
</script>

<style scoped>
.el-table /deep/ td {
  user-select: text !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/brands/BrandDetail.vue